module.exports = __webpack_public_path__ + "assets/53ebe4b180628bd36050ee212838511f.png";